import {Component, OnInit, ViewChild} from '@angular/core';
import {Route} from '../../enum/route';
import {ProposalDetailPageActions} from '../../store/proposal/actions/proposal.actions';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../store/proposal/reducers/proposal.reducer';
import {
  selectDetailPageOffers,
  selectDetailPageProposal,
  selectDetailPageProposalTile,
  selectLoading
} from '../../store/proposal/selectors/proposal.selectors';
import {UserService} from '../../services/user/user.service';
import {map, Observable, Subject, takeUntil} from 'rxjs';
import {
  CreateOfferContainerComponent
} from '../../components/proposal-details-components/create-offer-tab/create-offer-container/create-offer-container.component';
import {Offer} from '../../model/offer/offer';

@Component({
    selector: 'app-create-offer',
    templateUrl: './create-offer.component.html',
    styleUrls: ['../../../styles/create-something.scss', '../../../styles/standard-elements.scss', './create-offer.component.scss'],
    standalone: false
})
export class CreateOfferComponent implements OnInit {
  Route = Route;

  proposal$ = this.proposalStore.select(selectDetailPageProposal);

  loading$ = this.proposalStore.select(selectLoading);
  proposalTile$ = this.proposalStore.select(selectDetailPageProposalTile);
  protected destroy$ = new Subject<void>();

  uploadInProgress: boolean = false;

  basedOnOfferId: string | null = null;
  originalOffer$: Observable<Offer>;



  @ViewChild(CreateOfferContainerComponent) createOfferComponent: CreateOfferContainerComponent;


  constructor(private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              readonly userService: UserService,
              public readonly proposalStore: Store<ProposalAppState>,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const proposalId = params['id'];
      if (!proposalId) {
        this.router.navigate(['/' + Route.INSERATE]).then();
        return;
      }

      this.proposalStore.dispatch(ProposalDetailPageActions.load({proposalId: proposalId}));

      this.activatedRoute.queryParams.subscribe(queryParams => {
        this.basedOnOfferId = queryParams['basedOnOffer'] || null;
        if (this.basedOnOfferId) {
          this.originalOffer$ = this.proposalStore.select(selectDetailPageOffers).pipe(
            map(offers => offers.find(o => o.offerId === this.basedOnOfferId))
          );
        }
      })

    });

  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.router.navigate(['/' + Route.INSERATE]).then();
  }

  back() {
    this.proposal$.pipe(takeUntil(this.destroy$)).subscribe((proposal) =>
      this.router.navigate(['/' + Route.PROPOSAL_DETAILS, proposal.proposalInformation.id]).then());
  }

  submit() {
    this.createOfferComponent.navigateToPreview(this.basedOnOfferId);
  }

  disableSaveOfferButton(data: boolean) {
    this.uploadInProgress = data;
  }
}
